import { isUnknown } from '@myap/metadata'
import { profile, Spinner, isEmpty } from '@myap/ui-library'
import { ErrorNotification } from '@cb/apricot-react'
import { Provider } from '../_common/reactquery'
import ReturnToMyAP from '../_common/ReturnToMyAP'
import { useUserDetailsQuery, useEducationPeriodsQuery, useDeadlinesQuery } from '../../hooks'
import StudentApp from './StudentApp'

const getRedirectUrlAndSetReferrer = userDetails => {
  const { acceptedGeneralTAC, roles } = userDetails
  const { aproUrl, appId } = profile()
  const isUnknownUser = isUnknown(roles?.[0])

  if (acceptedGeneralTAC === false && !isUnknownUser) {
    return `${aproUrl}/termsandconditions`
  }

  return false
}

function MainApp() {
  const {
    data: userDetails = {},
    isLoading: isLoadingUserDetails,
    error: userDetailsError,
  } = useUserDetailsQuery('MainApp')
  const { studentId, isStudent } = userDetails
  const {
    data: educationPeriodsData = {},
    isInitialLoading: isLoadingEducationPeriods,
    error: educationPeriodsError,
  } = useEducationPeriodsQuery({ id: studentId, myDetailsComplete: !isLoadingUserDetails })
  const { currentEducationPeriod = {} } = educationPeriodsData
  const {
    data: deadlinesData,
    error: deadlinesError,
    isInitialLoading: isLoadingDeadlines,
  } = useDeadlinesQuery({
    educationPeriodCd: currentEducationPeriod?.code,
    educationPeriodsComplete: !isLoadingEducationPeriods,
  })
  const redirect = getRedirectUrlAndSetReferrer(userDetails, currentEducationPeriod)

  if (redirect) {
    window.location = redirect
    return <Spinner spinnerId="appSpinner" size="64" />
  }

  if (userDetailsError || educationPeriodsError || deadlinesError) {
    return (
      <div className="container cb-margin-top-48 cb-no-padding" tabIndex="-1">
        <ReturnToMyAP />
        <ErrorNotification title="Error">
          Error retrieving data. Please try again later.
        </ErrorNotification>
      </div>
    )
  }

  if (isLoadingUserDetails || isLoadingEducationPeriods || isLoadingDeadlines) {
    return <Spinner size="64" />
  }

  if (isStudent && educationPeriodsData?.educationPeriods?.length && !isEmpty(deadlinesData)) {
    return <StudentApp />
  }

  return null
}

export default () => {
  return (
    <Provider>
      <div id="myap-root">
        <MainApp />
      </div>
    </Provider>
  )
}
